import * as svg from "../../../assets/search-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const SearchIcon = iconBuilder(svg, "SearchIcon", "0 0 16 16");
